{
  "roughness": 0.6,
  "metalness": 0,
  "envMapIntensity": 0.15
}
